export default {
  boolean: { 0: '否', 1: '是' },
  boolean2: { 0: '是', 1: '否' },
  has: { 0: '无', 1: '有' },
  isHidden: { 0: '启用', 1: '禁用' },
  isDisable: { 0: '启用', 1: '禁用' },
  sex: { 0: '女', 1: '男' },
  subjectType: { 1: '自选', 2: '抽题' },
  screenStatus: { 0: '不限', 1: '竖屏', 2: '横屏' },
  status: { 0: '待填写', 1: '待发布', 2: '已发布', 3: '已关闭' },
  categoryLevel: { 1: '一级分类', 2: '二级专业', 3: '三级级别' },
  payStatus: { 0: '未支付', 1: '已支付', 2: '已退款' },
  isPayed: { 0: '待付款', 1: '已付款' },
  isImport: { 0: '线上', 1: '导入' },
  auditStatus: { 1: '待审核', 2: '审核通过', 3: '审核未通过', 4: '已取消' },
  questionType: { 1: '模拟', 2: '正式' },
  newsType: { 0: '图文' },
  newsModule: { 0: '协会动态', 1: '会员中心', 2: '赛事活动', 3: '考级咨询' },
  linkType: { 0: '文章', 1: '外链' },
  payType: { 0: '支付宝', 1: '微信' },
  tradeState: { 0: '待支付', 1: '未支付', 2: '已支付', 3: '已取消', 4: '申请退款', 5: '已退款', 6: '退款失败' },
  idType: { '1': '身份证', '2': '港澳通行证', '3': '护照', '4': '台胞证' },
  smsType: { 0: '注册', 1: '找回密码', 2: '登录', 3: '修改账号' },
  dimensionType: { 0: '科目评分', 1: '综合评分' },
  evaluateType: { 0: '自定义设置', 1: '分值设置' },
  evaluateStatus: { 0: '未设置', 1: '已设置', 2: '评分中', 3: '已评分', 4: '已发布' },
  isEvaluate: { 0: '未评审', 1: '已评审' },
  isPublish: { 0: '未发布', 1: '已发布' },
  refundStatus: { 1: '退款中', 2: '已退款' }
}
